<template>

  <div style="padding-bottom: 300px;">
     <div style="font-size: 28px;font-weight: 600;">
       开奖数据

     </div>

		 <div class="lastinfoBox" style="font-size: 28px;">
					 <div>
						  第<span style="color: red;">{{record.number}}</span> 期  {{record.time}}
					 </div>
					 <div>

              <div>
                   <!-- <img :src=" '../../img/'+record.simple1+'.png'" alt="" style="width: 60px;height: 60px;"> -->
                   <img v-bind:src="require('../../img/'+record.simple1+'.png')" style="width: 60px;height: 60px;">
                    <img v-bind:src="require('../../img/'+record.simple2+'.png')"  style="width: 60px;height: 60px;">
                     <img v-bind:src="require('../../img/'+record.simple3+'.png')"  style="width: 60px;height: 60px;">
                      <img v-bind:src="require('../../img/'+record.simple4+'.png')"  style="width: 60px;height: 60px;">
                       <img v-bind:src="require('../../img/'+record.simple5+'.png')"  style="width: 60px;height: 60px;">
                        <img v-bind:src="require('../../img/'+record.simple6+'.png')"  style="width: 60px;height: 60px;">
                         <img v-bind:src="require('../../img/'+record.complex+'.png')"  style="width: 60px;height: 60px;">
              </div>
              <p class="num"> <span>{{record.simple1}}</span><span>{{record.simple2}}</span><span>{{record.simple3}}</span><span>{{record.simple4}}</span>
              <span>{{record.simple5}}</span><span>{{record.simple6}}</span><span>{{record.complex}}</span></p>
							<p class="num"> <span v-for="(item) in record.animalJson">{{item}}</span>
							</p>
					 </div>

		 </div>
		 <div style="margin-top: 20px;">
			 <div style="font-size: 28px;">
				 正在等待开奖期数: 第<span style="color: red;">{{nextNumber}}</span>期 - <span> {{nextTime}}</span>
			 </div>
			 <div class="openBox" style="min-width: 840px;margin-top: 20px;">
				 <div style="font-size: 30px;padding: 20px 0 ;">填写开奖数据</div>
				 <div class="openNumBox" style="display: flex;justify-content: flex-start;margin: 14px 0;">
					 <div>
						   1:<Input v-model="formData.num1"   type="number"  size="small" placeholder="" style="width: 80px;height: 40px;" />
					 </div>
					 <div>
					 						   2:<Input v-model="formData.num2" type="number"  size="small" placeholder="" style="width: 80px;height: 40px;" />
					 </div>
					 <div>
					 						   3:<Input v-model="formData.num3"  type="number" size="small" placeholder="" style="width: 80px;height: 40px;" />
					 </div>
					 <div>
					 						   4:<Input v-model="formData.num4"  type="number" size="small" placeholder="" style="width: 80px;height: 40px;" />
					 </div>
					 <div>
					 						   5:<Input v-model="formData.num5"  type="number" size="small" placeholder="" style="width: 80px;height: 40px;" />
					 </div>
					 <div>
					 						  6:<Input v-model="formData.num6"  type="number" size="small" placeholder="" style="width: 80px;height: 40px;" />
					 </div>
					 <div>
					 						   特码:<Input v-model="formData.complex"  type="number" size="small" placeholder="" style="width: 80px;height: 40px;" />
					 </div>




				 </div>
				 <div>
					  <div>
					 						 下期开奖期数:<Input v-model="formData.nextNumber"   type="number"  size="small"  placeholder="" style="width: 80px;height: 40px;margin-top: 10px;" />
					  </div>
						<div>
											 下期开奖时间:<DatePicker type="datetime" :value="formData.nextTime" format="yyyy-MM-dd HH:mm"  placeholder="请选择时间" style="width: 200px" @on-change='setDate'></DatePicker>

						</div>
				 </div>
				 <div style="margin-top: 60px;">
					    <Button type="primary" @click="lockBtn">锁定开奖</Button>
              <Button type="success" :loading="loading" @click="submitBtn" :disabled="lock">
                     <span v-if="!loading">确认开奖</span>
                     <span v-else>Loading...</span>
                 </Button>

				 </div>


			 </div>


		 </div>
    <div>

    </div>

  </div>
</template>

<script>

  export default{
    			created(){  //生命周期里接收参数
  // console.log(this.baseURL )
                this.getData()
								this.getNext()
								this.getten()
    	},
    	data(){
    		 return {
    			  record:[],
            loading:false,
						lock:true,
						 nextNumber:'',
					 	nextTime:'',
						openDate:'',
						formData:{
							num1:'',
							num2:'',
							num3:'',
							num4:'',
							num5:'',
							num6:'',
							complex:'',
							nextTime:'',
							nextNumber:'',

						},
            time:["20:30","19:10","21:00","19:05","22:35"]
    			 }
    	},
    	methods:{
    		   getData() {
                         var params = {
                           pageNum:1,
                           pageSize:2
                         }

                      	  this.post('apis/mark/record/get',params).then(res => {
                          	console.log(res)
                            if(res.status == 1){
                                  this.record = res.data.records[0]
                                  // replace(/-/g,'')

                                  var anima = this.record.animalName.replace(/-/g,'')
                                  // str.charAt(2)
                                console.log(anima)
                                  var arr=[]
                                  for(var i =0;i<7;i++){
                                    arr.push(anima.charAt(i))
                                  }
																	this.record.animalJson = arr
                                  console.log(arr)

                            }

                          }).catch(err => {             //
                            console.log(err)
                          });


                  },
                 setDate(e){
									 console.log(e)
									 this.formData.nextTime = e

								 },
								 submitBtn(){
									 if( !this.lock){
										  this.kaijiang()
									 }else{
										   this.$Message.error('请先填写全部信息锁定之后开奖');
										 }

								 },
								 lockBtn(){
									         var that= this
									 									 var params = this.formData
									         var numberArr = [this.formData.num1,this.formData.num2,this.formData.num3,this.formData.num4,this.formData.num5,this.formData.num6,this.formData.complex]

									         var nary = numberArr.sort();
									 if(numberArr.length == 7 && this.formData.num1 &&this.formData.num2 &&this.formData.num3&&this.formData.num4&&this.formData.num5&&this.formData.num6 && this.formData.complex &&this.formData.nextTime &&this.formData.nextNumber){
									             var hasSmallNumber = false
									           for (var i = 0; i < numberArr.length; i++) {

									               if (nary[i] == nary[i + 1]) {
									                   console.log('有相同数字')
									                   this.$Message.error('有相同数字');
									                     hasSmallNumber = true
									                  }
									           }
									           if(!hasSmallNumber){
									             that.post('apis/mark/record/add',params).then(res => {
									             	console.log(res)
									               if(res.status == 1){  //可以点击开奖
																  this.$Message.success('锁定成功，等待开奖');
                                  setTimeout(function(){
                                    that.lock = false
                                  },2400)

									               }

									             }).catch(err => {             //
									              console.log(err)
									             });
									           }

									           }else{
									             console.log('填写完整数字')
									              this.$Message.error('填写完整数字');
									           }





									 },
								 getNext(){
									   this.post('apis/mark/record/getNextLottery').then(res => {
									 	console.log(res)
									   if(res.status == 1){
									          this.nextNumber = res.data.nextNumber
													  this.nextTime = res.data.nextTime
                                             this.formData.nextNumber = ++ res.data.nextNumber
											  console.log('时间', this.time[sessionStorage.getItem('type')-1])
											  var dd = new Date(res.data.nextTime);
											   dd.setDate(dd.getDate() + 1);
											   var y = dd.getFullYear();
											   var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
											   var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
											   console.log(y + "-" + m + "-" + d) ;
											   this.formData.nextTime = y + "-" + m + "-" + d +" "+ this.time[sessionStorage.getItem('type')-1]

									   }

									 }).catch(err => {             //
									   console.log(err)
									 });

								 },
								 kaijiang(){
									 
									this.lock=true
									   this.post('apis/mark/record/lottery').then(res => {
									 	console.log(res)
									   if(res.status == 1){
									        this.$Message.success('开奖成功');
                  this.loading = false
									   }else{
										     this.$Message.error('开奖失败');
											 	this.lock=false
									   }

									 }).catch(err => {             //
									   console.log(err)
									 });

								 },
								 getten(){
								 									   this.post('apis/mark/record/getTenComplex').then(res => {
								 									 	console.log(res)
								 									   if(res.status == 1){
																					var dataNumer = []
																					var complex = []
																					for(var i = 0;i<10;i++){
																						dataNumer.push( res.data.records[i].number)
																						complex.push( res.data.records[i].complex)
																					}
																					console.log(dataNumer)
																					console.log(complex)


								 									   }

								 									 }).catch(err => {             //
								 									   console.log(err)
								 									 });

								 }


              }

    }



</script>

<style>
	 .num span{
		 padding: 0 10px;
	 };
	  .num span:nth-last-child{
			color: #42B983;
			font-size: 30px;
		}
		.openNumBox{
			display: flex;
			justify-content: flex-start;
		}
		.openNumBox div{
			margin-right: 20px;
		}
			.openNumBox input{
				height: 30px;
			}
			.openBox{
				border: 1px solid lightslategray;
				padding: 10px 20px;
			}
</style>



// WEBPACK FOOTER //
// src/components/open.vue